export default __webpack_public_path__ + "static/media/landing-bg.f5372b99.png";